module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/znamenka-a-kozni-vyrustky_2_before.jpg
// module id = 1008
// module chunks = 0